import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import Utils from '../../utils';
import MultiAppAuthenticationPopup from './Popup';
import Loader, { LoaderType, LoaderStepName } from '../../components/Loader';
import MultiAppAuthenticationForm from './Form';

import { MultiAppAuthenticationInfosState } from './reducer';
import { StyledMultiAppAuthentication, MultiAppAuthenticationTitle, WebpublicationLogo, SwitchToDemoViewBlock,
	SwitchToDemoFormButton, MultiAppAuthenticationContainer } from './styles';
import { AuthenticationMethods, AuthenticationMethodButton, SamlIframeOrigin, SamlAuthenticationIframe
} from '../Authentication/styles';
import { AUTH_METHODS, MultiAppAuthenticationViewMode, AuthMethod } from './constants';
import { Translate } from 'react-redux-i18n';
import UrlUtils from '../../utils/url';
import { signIn } from './actions';
import ApiUtils from '../../utils/api';

export interface MultiAppAuthenticationProps {
	multiAppAuthenticationInfos: MultiAppAuthenticationInfosState;
	dispatch: Dispatch<StoreState>;
}

interface MultiAppAuthenticationState {
	isSelectAppPopupOpen: boolean;
	shouldRememberCredentials: boolean;
	viewMode: MultiAppAuthenticationViewMode;
	hasLoader: boolean;
	method?: AuthMethod;
}

export class MultiAppAuthentication extends React.Component<MultiAppAuthenticationProps, MultiAppAuthenticationState> {

	constructor(props: MultiAppAuthenticationProps) {
		super(props);
		const { accessibleApps } = props.multiAppAuthenticationInfos;

		this.state = {
			isSelectAppPopupOpen: accessibleApps.length > 1,
			shouldRememberCredentials: true,
			viewMode: MultiAppAuthenticationViewMode.Company,
			hasLoader: false,
		};

		this.onPopupClosed = this.onPopupClosed.bind(this);
		this.switchToDemoView = this.switchToDemoView.bind(this);
		this.switchToLoginView = this.switchToLoginView.bind(this);
		this.renderMethodButtons = this.renderMethodButtons.bind(this);
		this.setLoader = this.setLoader.bind(this);
		this.switchViewMode = this.switchViewMode.bind(this);
		this.handleOrgAuthentication = this.handleOrgAuthentication.bind(this);
	}

	componentWillMount() {
		window.addEventListener('message', this.handleOrgAuthentication);
	}

	componentWillReceiveProps(nextProps: MultiAppAuthenticationProps) {
		if (this.props.multiAppAuthenticationInfos.accessibleApps !== nextProps.multiAppAuthenticationInfos.accessibleApps) {
			this.setState({ isSelectAppPopupOpen: nextProps.multiAppAuthenticationInfos.accessibleApps.length > 1 });
		}
	}

	componentWillUnMount() {
		window.addEventListener('message', this.handleOrgAuthentication);
	}

	handleOrgAuthentication = (e: MessageEvent) => {
		const data: string = e.data;
		const { dispatch, multiAppAuthenticationInfos } = this.props;
		const adminToken = 'wp_admin_token';

		if (data && data.indexOf(adminToken) === 0) {
			const company = multiAppAuthenticationInfos.credentials && multiAppAuthenticationInfos.credentials.company ? multiAppAuthenticationInfos.credentials.company : '';
			const token = data.slice(data.indexOf('=') + 1);
			dispatch(signIn({ token, company, method: this.state.method }, true));
		}
	}

	onPopupClosed(): void {
		this.setState({ isSelectAppPopupOpen: false });
	}

	selectAuthMethod(method: AuthMethod): void {
		this.setState({ method });

		if (method === AuthMethod.Webpublication) {
			return this.switchToLoginView();
		} else {
			return this.switchToOrgLoginView();
		}
	}

	onClickForgotPassword(): void {
		const server = ApiUtils.multiAppAuthenticationServer;
		if (server) {
			const url = UrlUtils.getResetAspPasswordUrl(server);
			window.open(url, '_blank');
		}
	}

	switchToDemoView(): void {
		this.switchViewMode(MultiAppAuthenticationViewMode.Creation);
	}

	switchToLoginView(): void {
		this.switchViewMode(MultiAppAuthenticationViewMode.Login);
	}

	switchToOrgLoginView(): void {
		this.switchViewMode(MultiAppAuthenticationViewMode.OrgLogin);
	}

	switchViewMode(viewMode: MultiAppAuthenticationViewMode): void {
		this.setState({ viewMode });
	}

	setLoader(hasLoader: boolean): void {
		this.setState({ hasLoader });
	}

	get isLoginView(): boolean {
		return this.state.viewMode === MultiAppAuthenticationViewMode.Login;
	}

	get isOrgLoginView(): boolean {
		return this.state.viewMode === MultiAppAuthenticationViewMode.OrgLogin;
	}

	get isCompanyView(): boolean {
		return this.state.viewMode === MultiAppAuthenticationViewMode.Company;
	}

	get isCreationView(): boolean {
		return this.state.viewMode === MultiAppAuthenticationViewMode.Creation;
	}

	get isMethodView(): boolean {
		return this.state.viewMode === MultiAppAuthenticationViewMode.Method;
	}



	get isOrgMethod(): boolean {
		const { method } = this.state;
		return method && method !== AuthMethod.Webpublication ? true : false;
	}

	get viewTextTitle(): string {
		const { isLoginView, isCompanyView, isCreationView, isMethodView } = this;

		if (isCompanyView) {
			return 'messages.already_member';
		} else if (isLoginView) {
			return 'messages.webpublication_method';
		} else if (isCreationView) {
			return 'messages.test_our_demo';
		} else if (isMethodView) {
			return 'messages.choose_authent_method';
		}

		return '';
	}

	renderMethodButtons() {
		const { orgAuthMethods } = this.props.multiAppAuthenticationInfos;

		return orgAuthMethods.map(method => {
			return (
				<AuthenticationMethodButton onClick={() => this.selectAuthMethod(method)} key={`button-${method}`}>
					<Translate value={`${AUTH_METHODS[method].text}`} />
				</AuthenticationMethodButton>
			);
		});
	}

	render() {
		const { isSelectAppPopupOpen, shouldRememberCredentials, hasLoader, viewMode } = this.state;
		const { credentials } = this.props.multiAppAuthenticationInfos;
		const server = ApiUtils.multiAppAuthenticationServer;
		const { isCompanyView, isMethodView, isOrgLoginView } = this;
		const company = credentials && credentials.company ? credentials.company : '';

		return (
			<StyledMultiAppAuthentication>
				{isOrgLoginView &&
					<SamlAuthenticationIframe key="messageinterceptor-iframe" origin={SamlIframeOrigin.App} src={UrlUtils.getMessageInterceptorUrl(server)}/>
				}
				{hasLoader &&
					<Loader loaderStep={{ step: LoaderStepName.Creating }} type={LoaderType.Overlay} />
				}
				{isSelectAppPopupOpen &&
					<MultiAppAuthenticationPopup
						onClose={this.onPopupClosed}
						shouldSaveGalleryConfig={shouldRememberCredentials}
					/>
				}
				{isOrgLoginView
					? <SamlAuthenticationIframe key="login-iframe" origin={SamlIframeOrigin.Authentication} src={UrlUtils.getOrgLoginUrl(server, company)} />
					: <MultiAppAuthenticationContainer>
						<WebpublicationLogo>{Utils.getSvgIcon('webpublication')}</WebpublicationLogo>
						{isCompanyView &&
							<SwitchToDemoViewBlock>
								<SwitchToDemoFormButton onClick={this.switchToDemoView}>
									<Translate value="messages.test_our_demo" />
								</SwitchToDemoFormButton>
							</SwitchToDemoViewBlock>
						}
						<MultiAppAuthenticationTitle>
							<Translate value={this.viewTextTitle} />
						</MultiAppAuthenticationTitle>
						{!isMethodView ?
							<MultiAppAuthenticationForm
								viewMode={viewMode}
								switchViewMode={this.switchViewMode}
								setLoader={this.setLoader}
							/>
							: <AuthenticationMethods>
								{this.renderMethodButtons()}
							</AuthenticationMethods>
						}
					</MultiAppAuthenticationContainer>
				}
			</StyledMultiAppAuthentication>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { multiAppAuthenticationInfos } = state;
	return { multiAppAuthenticationInfos };
};

export default connect(mapStateToProps)(MultiAppAuthentication);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/index.tsx